import ReportCycleUpsellSvg from 'ext-ui/svg/illustration/ReportCycleUpsellSvg'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import NotFoundBackgroundPageContent from 'src/components/NotFoundBackgroundPageContent/NotFoundBackgroundPageContent'
import OrgExpenseReportSettingsBox from 'src/components/OrgExpenseReportCycleSettingsBox/OrgExpenseReportCycleSettingsBox'
import SaasUpgradeOrContent from 'src/feature/SaasUpgradeOrContent/SaasUpgradeOrContent'
import Trns, { useTranslate } from 'src/localization/Trns'
import { UserFeature } from 'src/models/user.models'
import Lnk from 'src/navigation/Lnk'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import { selectAppName } from 'src/redux/selectors/session.selectors'

const ExpenseSettings: React.FC = () => {
  const translate = useTranslate()
  const appName = useSelector(selectAppName)
  const user = useSelector(selectUserListModelFromState)

  if (!user?.hasOrgAdminPermissions) {
    return <NotFoundBackgroundPageContent />
  }

  return (
    <>
      <Helmet>
        <title>{`Expense Settings | ${appName}`}</title>
        <meta
          name="description"
          content={`Expense Settings page of ${appName}`}
        />
      </Helmet>
      <SaasUpgradeOrContent
        illustration={<ReportCycleUpsellSvg />}
        title={translate('Expense Report Cycle')}
        description={translate(
          "For each billing cycle, you'll receive an automatically generated expense report matching your bank statement—complete with all virtual* and physical card transactions (if applicable).",
        )}
        disclaimer={
          <Trns
            source="*Virtual cards available for ${selectIssuersLink}"
            expressions={{
              selectIssuersLink: (
                <Lnk
                  className="underline-link"
                  href="https://support.paywithextend.com/hc/en-us/sections/35632429037079-Registering-a-Card-Account"
                  ariaLabel={translate('select issuers')}
                >
                  {translate('select issuers')}
                </Lnk>
              ),
            }}
          />
        }
        ctaDetailSrc={
          'Upgrade to ${tier} today and receive automatically generated expense reports synced with your billing cycle.'
        }
        feature={UserFeature.AUTOMATED_EXPENSE_REPORTS}
      >
        <OrgExpenseReportSettingsBox />
      </SaasUpgradeOrContent>
    </>
  )
}

export default ExpenseSettings
